import React, { useState } from "react";
import { Col, Modal } from "react-bootstrap";
import "../../assets/styles/local/settings.css";

const InfoSaveOrNotPopup = (props) => {

  // const [popups, setPopups] = useState(props?.popupsStat);
  const { hendleClickNo } = props;
  return (
    <div
      style={{
        border: "none",
      }}>
      <Modal
        {...props}
        centered
        // show={popups}
        // onHide={handleClose}
        // setpop={setPopups}
        className="modelwidth-translation"
        style={{
          border: "none",
          backgroundColor: "transparent",
          opacity: 0.9,
        }}>
        <Modal.Body
          style={{
            // border:"#f00 solid 6px",
            border: "none !important",
            outline: "none",
            borderRadius: "clamp(10px, 0.521vw, 0.732vw)",
          }}>
          <div
            className="flex_class "
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              alignItems: "center",
              border: "none",
              justifyContent: "start",
              //   marginTop: "clamp(60px, 4.729vw,5.729vw)",
              padding: "10% 0",
            }}>
            <div className=" text-line1">
              The changes made will not be save.
            </div>

            <div
              className="text-line1 "
              style={{ marginTop: "clamp(25px, 2.021vw,2.021vw)" }}>
              Do you want to proceed?
            </div>

            <div
              className=""
              style={{ marginTop: "clamp(30px, 3.729vw,4.729vw)" }}>
              <button
                className="me-2  btn-no"
                onClick={() => {
                  // setPopups(false);
                  // window.location.reload();
                  props.setPopups(false);
                }}
                style={{
                  fontSize: "clamp(12px, 0.833vw, 0.833vw)",
                  fontWeight: 800,
                }}>
                No
              </button>
              <button
                className="ms-2 btn-yes"
                onClick={hendleClickNo}
                style={{
                  fontSize: "clamp(12px, 0.833vw, 0.833vw)",
                  fontWeight: 800,
                }}>
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default InfoSaveOrNotPopup;
